module.exports = __webpack_public_path__ + "static/img/frame_intokk.c55e598.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate/frame_intokk.png
// module id = 6Bt5
// module chunks = 1